import React, { useState, FC } from 'react';
import { useTranslate } from 'react-admin';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';

import { notification } from '~/ducks/snackbarNotifications';
import { changePassword } from '~/api/user';
import onError from '~/errorsHandler';
import { DialogContent } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles({
  root: {
    width: 520,
  },
  applyButton: {
    minWidth: 125,
  },
});

interface Props {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
}

const ChangePasswordModal: FC<Props> = ({ isOpen, setOpen }) => {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const translate = useTranslate();
  const translateLabel = (key: string): string => translate(`layout.ChangePasswordModal.${key}`);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await changePassword();
      setOpen(false);
      dispatch(
        notification({
          message: translateLabel('success'),
          severity: 'success',
        })
      );
    } catch (error) {
      onError(error);
    }
    setLoading(false);
  };

  const classes = useStyles();

  return (
    <Dialog open={isOpen} onClose={handleClose} aria-labelledby='form-dialog-title'>
      <div className={classes.root}>
        <DialogTitle id='form-dialog-title'>{translateLabel('_')}</DialogTitle>
        <DialogContent>
          <Alert severity='warning'>{translateLabel('passwordResetWarning')}</Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary'>
            {translate('ra.action.cancel')}
          </Button>
          <Button className={classes.applyButton} onClick={handleSubmit} color='primary'>
            {loading ? (
              <CircularProgress size={24} thickness={2} />
            ) : (
              translateLabel('resetPassword')
            )}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default ChangePasswordModal;
